module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('em', [_vm._v("Custer’s Roommate")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY IN THE MORNING OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULY 20, 1861, BREVET 2ND")]), _vm._v(" Lt. Jim Parker of the Fourth U.S. Infantry lay asleep in bed when his West Point pal and former roommate George Armstrong Custer showed up unannounced at his rented room in the Ebbitt House in Washington, D.C."), _c('a', {
    attrs: {
      "id": "ren16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en16",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" Custer recalled years later that he anxiously asked Parker for the latest news from Virginia, where two opposing armies were converging on nearby Manassas Junction and all expected an engagement at any hour (the First Battle of Manassas occurred the following day). Custer then inquired about Kentucky-born Parker’s plans, though he might have already guessed the answer. Parker pointed to a document lying upon a table near his bed and Custer read it, an official order from the U.S. War Department dismissing Parker from the army “for having tendered his resignation in the face of the enemy.”"), _c('a', {
    attrs: {
      "id": "ren17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en17",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After spending the next hour discussing the war, Custer remembered, “I bade a fond farewell to my former friend and classmate, with whom I had lived on terms of closer intimacy and companionship than with any other being. We had eaten day by day at the same table, had struggled together in the effort to master the same problems of study; we had marched by each other’s side year after year, elbow to elbow, when engaged in the duties of drill, parade, etc., and had shared our blankets with each other when learning the requirements of camp life. Henceforth this was all to be thrust from our memory as far as possible, and our paths and aims in life were to run counter to each other in the future.”"), _c('a', {
    attrs: {
      "id": "ren18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en18",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Their friendship might have seemed unlikely: One historian describes Parker as “a stout, slow-moving, rugged young man, almost the physical opposite of Custer.”"), _c('a', {
    attrs: {
      "id": "ren19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en19",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" However, the two young men had hit it off when they met at West Point in 1857. Both belonged to Company D, a generally rowdy group mostly from the South and West. According to one cadet, the pair “fooled away many an hour that should have been devoted to study.”"), _c('a', {
    attrs: {
      "id": "ren20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en20",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Lt. Col. James Porter Parker, First Mississippi Light Artillery "), _c('em', [_vm._v("Carte de visite")]), _vm._v(" by unidentified photographer, about 1865. John Sickles collection.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("They ranked at the bottom of their class in grades and racked up demerits by the score. School officials dismissed Parker in June 1861 for exceeding the limit of demerits, and he did not graduate with Custer and the rest of his class."), _c('a', {
    attrs: {
      "id": "ren21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en21",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" Despite his deficiency in conduct, the Union army offered him a commission as a brevet second lieutenant. He accepted it, and reported to Washington for orders. But he could not bring himself to fight against his home state, and he had resigned shortly before Custer’s surprise visit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Custer, the dashing and flamboyant cavalryman, fought his way to major general. The solid and slow-moving Parker received a lieutenant colonel’s commission in the Confederate army and joined the First Mississippi Light Artillery. Dispatched to Vicksburg in May 1862, Parker and his cannoneers defended that key Confederate bastion against advancing Union ironclad warships and gunboats. By July, the Union vessels had backed off. Local commanders commended Parker for his assistance. Later that year, he moved to Port Hudson, Louisiana, took charge of several batteries, and assisted in the defense of the town during the forty-eight-day siege that ended with the surrender of the garrison on July 8, 1863, four days after the fall of Vicksburg."), _c('a', {
    attrs: {
      "id": "ren22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en22",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" Parker spent the next two years in Northern prisons. He gained his release after signing the oath of allegiance in July 1865.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the war, he made his way to the silver-mining boom-town of Kingston in the New Mexico Territory."), _c('a', {
    attrs: {
      "id": "ren23"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en23",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" He remained there after the great ore deposits were played out and worked as a surveyor. He died in 1918 at about age seventy-nine, outliving Custer by more than forty years. He never married.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Capt. Youel Gilbert Rust, Company E, Fourth Georgia Infantry")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Carte de visite")]), _vm._v(" by unidentified photographer, 1861–1862. David Wynn Vaughan collection.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5755fa64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 93
// module chunks = 0